import { Link } from 'react-router-dom';
import { Linkedin, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-brand-dark text-white">
      {/* Footer Content */}
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="font-serif text-2xl font-semibold text-white">
              Mattoo Consulting
            </Link>
            <p className="mt-4 text-brand-pale/70 max-w-md">
              Helping skilled migrants and overseas professionals land their ideal roles in Australia with personalised career coaching.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-brand-pale mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" onClick={() => window.scrollTo(0, 0)} className="text-brand-pale/70 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/packages" onClick={() => window.scrollTo(0, 0)} className="text-brand-pale/70 hover:text-white transition-colors">
                  Packages
                </Link>
              </li>
              <li>
                <Link to="/book-a-call" onClick={() => window.scrollTo(0, 0)} className="text-brand-pale/70 hover:text-white transition-colors">
                  Book a Call
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-brand-pale mb-4">Connect</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="https://www.linkedin.com/in/anantmattoo/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-brand-pale/70 hover:text-white transition-colors"
                >
                  <Linkedin size={18} /> LinkedIn
                </a>
              </li>
              <li>
                <a
                  href="mailto:info@mattooconsulting.com"
                  className="flex items-center gap-2 text-brand-pale/70 hover:text-white transition-colors"
                >
                  <Mail size={18} /> Email
                </a>
              </li>
              <li className="flex items-center gap-2 text-brand-pale/70">
                <MapPin size={18} /> Australia
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-brand-medium/30 mt-12 pt-8 text-center text-brand-pale/50 text-sm">
          <p>© 2023 Mattoo Consulting - All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
